import { render } from "./RoleUpdate.vue?vue&type=template&id=034422b8&scoped=true"
import script from "./RoleUpdate.vue?vue&type=script&lang=js"
export * from "./RoleUpdate.vue?vue&type=script&lang=js"

import "./RoleUpdate.vue?vue&type=style&index=0&id=034422b8&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\vrs_yii2_new\\vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-034422b8"]])

export default __exports__